import qs from 'query-string'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setOrderMethod } from '../../actions/orderActions'
import ModalForm from '../../components/common/modal-form'
import SelectMethod from '../../components/order/receive-method/SelectMethod'
import {
    ACCESS_SERVICES_MAP,
    APP_SERVICE,
    ORDER_METHOD,
    PARAMS_NAME,
} from '../../constants'
import useTimeWork from '../../hooks/useTimeWork'
import paths from '../../routes/paths'
import { getRestaurantServices } from '../../selectors'
import { isValidAddressForCalcDistance as isValidAddressForCalcDistanceSelector } from '../../selectors/order'
import SearchLocationContainer from './SearchLocationContainer'

const OrderMethodContainer = () => {
    const { orderMethod } = useSelector(state => state.OrderReducer)
    const isValidAddressForCalcDistance = useSelector(
        isValidAddressForCalcDistanceSelector
    )
    const { isOvertime } = useTimeWork({ useAgreeOvertime: true })
    const isOpenLogin = useSelector(state => state.AppReducer.showLoginForm)
    const services = useSelector(getRestaurantServices)
    const dispatch = useDispatch()
    const history = useHistory()

    const [step, setStep] = useState(0)
    const [isOpen, setIsOpen] = useState()

    const hasMultiServicesForWeb = [
        ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP],
        ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY],
    ].every(s => services.includes(s))

    const isInvail =  ![
        ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP],
        ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY],
    ].some(s => services.includes(s))
    const handleChooseReceiveMethod = method => {
        dispatch(setOrderMethod(method))
        if (method === ORDER_METHOD.DELIVERY) {
            setStep(1)
        } else {
            setIsOpen(false)
        }
    }

    const onSubmitLocationSuccess = deliverInfo =>
        deliverInfo?.distance !== undefined && setIsOpen(false)

    useEffect(() => {
        const { pathname, search } = history.location

        const invalidPath = () =>
            pathname.includes(paths.notFound) ||
            pathname.includes(paths.verifyQRCode) ||
            pathname.includes(paths.verifyTable) ||
            pathname.includes(paths.unSupport)

        const isDoneOrder = () => {
            const params = qs.parse(search)

            return (
                params[PARAMS_NAME.ORDER_GO_ID] ||
                params[PARAMS_NAME.ORDER_WEB_ID]
            )
        }

        const checkShowModal = () => {
            if (
                APP_SERVICE !== ACCESS_SERVICES_MAP.WEB ||
                isDoneOrder() ||
                invalidPath() ||
                isOvertime
            ) {
                return isOpen && setIsOpen(false)
            }

            if (!orderMethod) {
                if (hasMultiServicesForWeb) {
                    setIsOpen(true)
                    setStep(0)
                } else {
                    const pickupOnly = services.includes(
                        ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP]
                    )

                    if (pickupOnly) {
                        return dispatch(setOrderMethod(ORDER_METHOD.PICKUP))
                    }

                    dispatch(setOrderMethod(ORDER_METHOD.DELIVERY))
                    setIsOpen(true)
                    console.log("first")
                    setStep(1)
                }

                return
            }

            if (
                orderMethod === ORDER_METHOD.DELIVERY &&
                !isValidAddressForCalcDistance
            ) {
                setIsOpen(true)
                setStep(1)
            }
        }

        checkShowModal()
    }, [history.location, orderMethod, isOvertime])

    const steps = [SelectMethod, SearchLocationContainer]
    const Comp = steps[step]
    return (
        <ModalForm
            onClose={
                step === 1 && hasMultiServicesForWeb ? () => setStep(0) : null
            }
            isOpen={isOpen && !isOpenLogin && !isInvail}
            centered
            rootClass="modal-method"
            containerClass={step === 2 ? 'content-error' : ''}
            btnCloseStyles={{
                color: 'ffffff'
            }}
        >
            <Comp
                onChooseMethod={handleChooseReceiveMethod}
                backStep={() => setStep(prev => prev - 1)}
                onSubmitLocationSuccess={onSubmitLocationSuccess}
                isOpen={isOpen && !isOpenLogin}
            />
        </ModalForm>
    )
}

export default OrderMethodContainer
